import { Box, Button, Form, Text } from '@factorialco/deprecated-design-system'
import {
  CompetenciesEditAudienceDocument,
  CompetencySettingsInfoFragment,
} from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { Audience, AudienceSelector } from 'modules/competencies/components/AudienceSelector'

interface CompetencyFormValues {
  everyone: boolean
  roleIds?: string[]
}

interface Props {
  competency: CompetencySettingsInfoFragment
}

export const AudienceSection = ({ competency }: Props) => {
  const [editAudience] = useMutation(CompetenciesEditAudienceDocument, {
    extractorFn: (data) => data.competenciesMutations.updateCompetenciesCompetency,
  })

  const onChangeSelector = (audience: Audience, selectedRoles: string[]) => {
    form.setValues({
      everyone: audience === 'all',
      roleIds: selectedRoles,
    })
  }

  const form = useForm<CompetencyFormValues>({
    defaultValues: {
      everyone: competency.everyone,
      roleIds: competency.roleIds || [],
    },
    async onSubmit(data, { setErrors }) {
      data.everyone = form.values.everyone
      const result = await editAudience({
        variables: {
          id: competency.id,
          everyone: data.everyone,
          roleIds: data.roleIds || [],
        },
      })

      const handled = handleResult(result, setErrors)

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('competencies_v3.settings.update_success'),
        })
      }

      return handled
    },
  })

  return (
    <Box>
      <Text.Header2>{i18n.t('competencies_v3.settings.audience.title')}</Text.Header2>
      <Form onSubmit={form.handleSubmit} padding={null}>
        <AudienceSelector
          onChangeSelector={onChangeSelector}
          defaultAudience={form.values.everyone ? 'all' : 'jobs'}
          defaultRoleIds={form.values.roleIds}
        />
        <Button submit>{i18n.t('common.save')}</Button>
      </Form>
    </Box>
  )
}
